import _extends from "@babel/runtime-corejs3/helpers/extends";
import { createVNode as _$cv, className as _$cn, createElementVNode as _$ce, map as _$ma, noop as _$no } from 'intact-vue';
import { makeStyles } from './styles';
import { getRestProps } from '../utils';
export default function ($props, $blocks, $__proto__) {
  var _classNameObj;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _$blocks = {};
  var __$blocks = {};
  var _this$get = this.get(),
    value = _this$get.value,
    disabled = _this$get.disabled,
    disable = _this$get.disable;
  var k = this.config.k;
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-scroll-select"] = true, _classNameObj[k + "-dragging"] = this.mouseEvents.dragging.value, _classNameObj[k + "-disabled"] = disabled, _classNameObj[makeStyles(k)] = true, _classNameObj);
  var _this$mouseEvents = this.mouseEvents,
    onStart = _this$mouseEvents.onStart,
    onWheel = _this$mouseEvents.onWheel,
    onClick = _this$mouseEvents.onClick;
  return _$cv('div', _extends({}, getRestProps(this), {
    'className': _$cn(classNameObj)
  }), [_$ce(2, 'div', _$ma(this.list.data.value, function ($value, $key) {
    var _$cn2;
    return _$ce(2, 'div', $value.label, 0, _$cn((_$cn2 = {}, _$cn2[k + "-scroll-select-item"] = true, _$cn2[k + "-active"] = $value.value === value, _$cn2[k + "-disabled"] = disabled || disable && disable.call(this, $value.value), _$cn2)), {
      'ev-click': !disabled ? onClick.bind(this, $value, $key) : null
    });
  }, $this), 4, _$cn(k + "-scroll-select-wrapper"), {
    'style': {
      transform: "translateY(" + this.translate.translate.value + "px)",
      marginTop: this.mouseEvents.marginTop.value + "px"
    },
    'ev-mousedown': !disabled ? onStart : null,
    'ev-wheel': !disabled ? onWheel : null
  }), $blocks.append ? _$ce(2, 'div', (_$blocks['append'] = function ($super) {
    return null;
  }, __$blocks['append'] = function ($super, data) {
    var block = $blocks['append'];
    var callBlock = function callBlock() {
      return _$blocks['append'].call($this, $super, data);
    };
    return block ? block.call($this, callBlock, data) : callBlock();
  }, __$blocks['append'](_$no)), 0, _$cn(k + "-scroll-select-append")) : undefined, _$ce(2, 'div', null, 1, _$cn(k + "-scroll-select-border"))]);
}
;